import React from "react";
import { Form, Checkbox } from "antd";

export const __FormCheckbox = (props) => {
    return (
        <Form.Item
            label={props.fieldLabel}
            name={props.fieldName}
            rules={props.rules}
            hidden={props.hidden}
            labelCol={props.labelCol}
            valuePropName="checked"
        >
            <Checkbox
                disabled={props.disable}
            >{props.checkboxName}</Checkbox>
        </Form.Item>
    )
}